import React, { useCallback, useContext, useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import FilterChip from 'components/Luxkit/Chips/FilterChip'
import { getCurrentDateLabel, getCurrentOccupancyLabel } from '../../FlashHotel/FlashHotelMobileVariant/FlashHotelMobileVariantUtils'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import LineUsersAltIcon from 'components/Luxkit/Icons/line/LineUsersAltIcon'
import ModalContext from 'contexts/ModalContext'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import OfferCapacityWithAgesSelection from '../../Filters/CapacityWithAges/OfferCapacityWithAgesSelection'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import OfferSidebarDatePicker from 'components/OfferPage/Filters/SidebarDatePicker/OfferSidebarDatePicker'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'

interface Props {
  offer: App.HotelOffer;
  dateLabel: string;
  occupancyLabel: string;
}

function AlwaysOnMobileStickyHeaderFilters(props: Props) {
  const {
    offer,
    dateLabel,
    occupancyLabel,
  } = props

  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const capacities = useMemo(() => {
    return offer.packages.flatMap((p) => p.roomRate.capacities)
  }, [offer.packages])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeHeaderFilter })
  }, [dispatch])

  const onOpenCalendar = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'checkin' })

    showModal((resolve) => <ModalBase mode="drawer">
      <form onSubmit={e => {
        e.preventDefault()
        resolve()
      }}
      >
        <OfferSidebarDatePicker />
      </form>
    </ModalBase>).then(onClose)
  }, [dispatch, showModal, onClose])

  const onOpenCapacity = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'capacity' })

    showModal(<ModalBase mode="drawer">
      <ModalHeader title="Who is going?" />
      <ModalBody>
        <OfferCapacityWithAgesSelection capacities={capacities} />
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Apply',
        }}
      />
    </ModalBase>).then(onClose)
  }, [dispatch, showModal, capacities, onClose])

  return (
    <Group direction="horizontal" gap={8}>
      <FilterChip
        startIcon={<LineCalendarIcon />}
        size="medium"
        onClick={onOpenCalendar}
      >
        {dateLabel || 'Anytime'}
      </FilterChip>
      {occupancyLabel && <FilterChip
        startIcon={<LineUsersAltIcon />}
        size="medium"
        onClick={onOpenCapacity}
      >
        {occupancyLabel}
      </FilterChip>}
    </Group>
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
  dateLabel: getCurrentDateLabel(state),
  occupancyLabel: getCurrentOccupancyLabel(state),
}), AlwaysOnMobileStickyHeaderFilters)
